module.exports = "/fonts/fa-solid-900.woff2?b15db15f746f29ffa02638cb455b8ec0";